import { useUserContextSelector } from '@app/main/utils';
import { AppointmentSlotApplyModal } from '@mod/schedule';
import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function useOnCancel() {
  const [searchParams] = useSearchParams();
  const providerId = searchParams.get('scheduledProviderId');
  const navigate = useNavigate();

  const onClose = useCallback(() => {
    searchParams.delete('scheduledProviderId');
    navigate(`?${searchParams.toString()}`);
  }, [navigate, searchParams]);

  return { providerId, onClose } as const;
}

export function ScheduleAppointmentModalWidget() {
  const { providerId, onClose } = useOnCancel();

  const [id, isPatient] = useUserContextSelector((x) => [x.id, x.hasRole('PATIENT')]);

  if (!isPatient || !providerId) return null;

  return <AppointmentSlotApplyModal hostId={providerId} visitorId={id} onClose={onClose} />;
}
